/**
 * Teams Actions
 *
 * Actions for managing teams in the NGXS store.
 */

import { Team } from './teams.state';

/**
 * Load teams for a list of partner IDs
 */
export class LoadTeams {
  static readonly type = '[Teams] Load Teams';
  constructor(public partnerIds: string[]) {}
}

/**
 * Load teams success
 */
export class LoadTeamsSuccess {
  static readonly type = '[Teams] Load Teams Success';
  constructor(public teams: Team[]) {}
}

/**
 * Load teams failure
 */
export class LoadTeamsFailure {
  static readonly type = '[Teams] Load Teams Failure';
  constructor(public error: string) {}
}

/**
 * Add a single team
 */
export class AddTeam {
  static readonly type = '[Teams] Add Team';
  constructor(public team: Team) {}
}

/**
 * Update a team
 */
export class UpdateTeam {
  static readonly type = '[Teams] Update Team';
  constructor(public teamId: string, public updates: Partial<Team>) {}
}

/**
 * Remove a team
 */
export class RemoveTeam {
  static readonly type = '[Teams] Remove Team';
  constructor(public teamId: string) {}
}

/**
 * Clear all teams
 */
export class ClearTeams {
  static readonly type = '[Teams] Clear Teams';
}

/**
 * Set loading state
 */
export class SetTeamsLoading {
  static readonly type = '[Teams] Set Loading';
  constructor(public loading: boolean) {}
}

/**
 * Clear error
 */
export class ClearTeamsError {
  static readonly type = '[Teams] Clear Error';
}

/**
 * Set team profile
 * 
 * Sets the user's profile for a specific team (local only, not persisted)
 */
export class SetTeamProfile {
  static readonly type = '[Teams] Set Team Profile';
  constructor(public teamId: string, public profile: any) {}
}

